export default __webpack_public_path__ + "static/media/login_background.edc2e406.jpg";